
window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            'Authorization' : 'Bearer ' + $('meta[name="jwt-token"]').attr('content')
        }
    });

} catch (e) {
    console.log(e)
}

let jQueryBridget = require('jquery-bridget');

require('../jquery-ui');

/**
 * Cookies
 */
window.Cookies = require('js-cookie');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    window.axios.defaults.headers.common['Authorization'] = "Bearer" + localStorage.getItem('laravel_token');
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

//Common utils
window.popsale = require('./utils').default;

//Material design web components
require('material-design-lite');
import * as mdc from 'material-components-web';
window.mdc = mdc;
window.mdc.autoInit();

//Smart banner
window.SmartBanner = require('smart-app-banner');

//Masonry
require('imagesloaded');
window.Masonry = require('masonry-layout');
jQueryBridget('masonry', window.Masonry, window.$);

//ColorPicker
import Picker from '@simonwep/pickr';

window.Pickr = Picker;

//Date Picker
window.Pikaday = require('pikaday');

//Data tables
window.dt = require('datatables.net');

//Tiny Editor
// require('../tinymce-editor');
window.TinyMDC = require('./popsale-tiny-mdc').default;

//Font awesome
require('@fortawesome/fontawesome-free/js/all.min');
